import { apiUrlV1, cancellableRequest } from 'src/services/api.js';

export const FeatureHintsService = {
  getFeatureHints(slug) {
    return cancellableRequest({
      url: `${apiUrlV1}/feature_hints`,
      method: 'get',
      params: {
        slugs: [slug],
      },
    });
  },
  markHintAsRead(slug) {
    return cancellableRequest({
      url: `${apiUrlV1}/feature_hints/${slug}/mark_as_read`,
      method: 'post',
    });
  },
};
